import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { FaSearch } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';

const SelectedGamePage = () => {
  const navigate = useNavigate();
  const { game_id } = useParams();
  const [gameData, setGameData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);


  useEffect(() => {
    // Fetch game data from the backend
    axios.get(process.env.REACT_APP_BACKEND_URL + `/api/v1/game/${game_id}`)
      .then(response => {
        setGameData(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the game data!', error);
      });
  }, [game_id]);

  const handleCameraButtonClick = () => {
    const data = {
      gameData: gameData
    };
    navigate('/camera', { state: data });
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  return (<>

    <header className="header fixed-top">
      <div className="navbar-area sticky">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand d-flex justify-content-between">
                <Link to="/" className="navbar-brand">
                  <img src={`${process.env.PUBLIC_URL}/logo_trans.png`} alt="Logo" style={{ maxHeight: '50px', width: 'auto' }} /> AR Board Games
                </Link>
                <Link to="/">

                  <FaSearch className="ms-auto" />Game
                </Link>

              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section id="home" className="hero-section">
      <div className="container">
        <div className="row align-items-center position-relative">
          <div className="col-lg-6">
            <div className="hero-content">
              <h1 className="wow fadeInUp" data-wow-delay=".4s">
                {gameData?.game.name_en}
              </h1>
              <a
                className="main-btn border-btn btn-hover wow fadeInUp"
                data-wow-delay=".6s"
                onClick={handleCameraButtonClick}
              >
                Start Camera
              </a>
              <a href="#gallery" className="scroll-bottom">
                <i className="lni lni-arrow-down"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="hero-img wow fadeInUp" data-wow-delay=".5s">
              <img className="img-fluid" style={{ maxHeight: '400px', width: 'auto' }} src={gameData?.game.box_image} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="gallery" className="gallery-section pt-5 mb-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xxl-5 col-xl-6 col-lg-8 col-md-9">
            <div className="section-title text-center mb-60">
              <h2 className="mb-25 wow fadeInUp" data-wow-delay=".2s">
                How does it work?
              </h2>
              <p className="wow fadeInUp" data-wow-delay=".4s">
                Point your camera at these marker images to see a visualization.
              </p>
            </div>
          </div>
        </div>
        <div className="gallery">
          {gameData?.images.map((image, index) => (
            <div className="gallery-item" key={index}>
              <div className="card">
                <img
                  src={image.image}
                  className="card-img-top img-fluid"
                  alt={`Game Image ${index + 1}`}
                  style={{ height: '150px', objectFit: 'contain', cursor: 'pointer' }}
                  onClick={() => handleImageClick(image)}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="row text-center">
          <div className="col d-inline-block mb-3">
            <a
              className="main-btn btn-hover border-btn wow fadeInUp"
              data-wow-delay=".6s"
              onClick={handleCameraButtonClick}
            >
              Start Camera
            </a>
          </div>
          <div className="col d-inline-block">
            <Link to="/" className="main-btn btn-hover border-btn wow fadeInUp" data-wow-delay=".6s">
              Search another game
            </Link>
          </div>
        </div>

      </div>
    </section>



    <Modal show={showModal} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={selectedImage?.image} className="img-fluid" alt="Selected Game Image" />
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
      </Modal.Footer>
    </Modal>

  </>);
};

export default SelectedGamePage;